import React from "react";
import { Link } from "react-router-dom";

import whyParticipateData from "../../data/home-why-participate.json";

export default function WhyParticipate() {
  return (
    <>
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-6">
              <div className="about-content-left section-heading">
                <span className="text-uppercase color-secondary sub-title">
                  {whyParticipateData.question}
                </span>
                <h2>{whyParticipateData.title}</h2>

                {whyParticipateData.sections.map((data) => (
                  <div key={data.id} className="single-feature mb-4">
                    <div className="d-flex align-items-center mb-2">
                      <span
                        className={`${data.icon} rounded mr-3 icon ${data["icon-bg-color"]}`}
                      ></span>
                      <h5 className="mb-0">{data.title}</h5>
                    </div>
                    <p>{data.description}</p>
                  </div>
                ))}

                <Link
                  className="btn solid-btn mt-2"
                  to={whyParticipateData["button-link"]}
                >
                  {whyParticipateData.button}
                </Link>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-content-right">
                <img
                  src="assets/img/about-img.png"
                  alt="about us"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
